import styled from 'styled-components';


const ServicesLayout = styled.div`
	position: relative;
	width: 100%;
	height: auto;
	margin-bottom: 40px;

	@media(max-width: 940px) {
		margin-bottom: 20px;
	}
`;

export {
	ServicesLayout,
};
